import { createSlice } from '@reduxjs/toolkit';
import { INPUT_PARAM_DEFAULTS } from '../../components/InputsForm/constants';
import { getDomain } from '../../utils/config';

const domain = getDomain();

const designListSlice = createSlice({
	name: 'designList',
	slice: 'designList',
	initialState: {
		fetchDesignListData: true,
		inputParameters: {
			vinMin: INPUT_PARAM_DEFAULTS.VIN_MIN[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
			vinMax: INPUT_PARAM_DEFAULTS.VIN_MAX[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
			vinNom: INPUT_PARAM_DEFAULTS.VIN_NOM,
			vout: INPUT_PARAM_DEFAULTS.VOUT[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
			iout: INPUT_PARAM_DEFAULTS.IOUT,
			ambientTemperature: INPUT_PARAM_DEFAULTS.AMB_TEMP,
			supplyType: INPUT_PARAM_DEFAULTS.SUPPLY_TYPE,
			lineFrequency: INPUT_PARAM_DEFAULTS.LINE_FREQUENCY,
			isolated: INPUT_PARAM_DEFAULTS.ISOLATED,
			automotiveDesign: INPUT_PARAM_DEFAULTS.AUTOMOTIVE_DESIGN
		},
		items: null,
		filteredItems: [],
		rangeFiltersMinMax: {},
		icPackages: []
	},
	reducers: {
		setFetchDesignListData(state, action) {
			if (action.payload) {
				state.items = [];
				state.filteredItems = [];
				state.rangeFiltersMinMax = {};
			}

			state.fetchDesignListData = action.payload;
		},
		setInputParameters(state, action) {
			const inputParameters = {};

			Object.keys(state.inputParameters).forEach(ipKey => {
				const newValue = action.payload[ipKey];
				inputParameters[ipKey] = newValue === null ? '' : newValue;
			});

			state.inputParameters = inputParameters;
		},
		setItems(state, action) {
			if (action.payload) {
				const items = action.payload;
				let counter = 1;
				items.sort((a, b) => (a.score > b.score ? 1 : -1));

				for (let i = items.length - 1; i >= 0; i--) {
					items[i].rank = counter++;
				}
				replaceDomain(items);
				markIncompletePrices(items);
				state.items = items;
				state.filteredItems = items;
			} else {
				state.items = null;
			}
		},
		filterItems(state, action) {
			state.filteredItems = action.payload;
		},
		setFiltersConstants(state, action) {
			const rfMinMax = {};
			action.payload.rangeFilters.forEach(rangeFilter => {
				if (rangeFilter.min !== rangeFilter.max) {
					rfMinMax[rangeFilter.name] = {
						min: rangeFilter.min,
						max: rangeFilter.max,
						marks: generateMarks(rangeFilter.min, rangeFilter.max),
						designCount: calcDesignDistribution(
							rangeFilter.min,
							rangeFilter.max,
							rangeFilter.name,
							action.payload.items
						)
					};
				}
			});

			state.rangeFiltersMinMax = rfMinMax;

			const icPackages = [];
			action.payload.icPackages.forEach(icp => {
				icPackages.push({ name: icp, label: icp });
			});

			state.icPackages = icPackages;
		}
	}
});

function truncFloat(number) {
	return parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]);
}

function markIncompletePrices(items) {
	items.forEach(item => {
		if (item.priceIsPartial) {
			item.designPriceFormatted += ' *';
		}
	});
}

const replaceDomain = items => {
	if (domain === 'onsemi.cn') {
		items.forEach(item => {
			const datasheetUrl = item.datasheetUrl;
			if (datasheetUrl && datasheetUrl.length > 0 && datasheetUrl.includes('onsemi.com')) {
				item.datasheetUrl = datasheetUrl.replace('onsemi.com', 'onsemi.cn');
			}
			const productPageUrl = item.productPageUrl;
			if (productPageUrl && productPageUrl.length > 0 && productPageUrl.includes('onsemi.com')) {
				item.productPageUrl = productPageUrl.replace('onsemi.com', 'onsemi.cn');
			}
		});
	}
};

// TODO: doplnit rozumne rozdelenie intervalu (napr. Switching frequency nema zmysel 8 marks pre interval 390 - 400)
function generateMarks(min, max) {
	const marksNum = 8;
	const step = (max - min) / marksNum;
	const marks = [];

	for (let i = 0; i <= marksNum; ++i) {
		marks.push({ value: truncFloat(min + step * i) });
	}

	return marks;
}

function calcDesignDistribution(min, max, designAttribute, items) {
	const jsonQuery = require('json-query');
	const marksNum = 8;
	const step = (max - min) / marksNum;
	const designCnt = [];

	for (let i = 0; i < marksNum; ++i) {
		designCnt.push(
			jsonQuery(
				'[* ' +
					designAttribute +
					'>=' +
					truncFloat(min + step * i) +
					'&' +
					designAttribute +
					'<=' +
					truncFloat(min + step * (i + 1)) +
					']',
				{
					data: items
				}
			).value.length
		);
	}

	return designCnt;
}

export default designListSlice;
